/** ****** LOGIN actions ******/
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_USER = 'LOGOUT_USER';
export const TOKEN_REFRESH = 'TOKEN_REFRESH';
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS';
export const TOKEN_REFRESH_ERROR = 'TOKEN_REFRESH_ERROR';
export const SET_USER_DISABLED = 'SET_USER_DISABLED';
export const TIMEOUT_CREATE = 'TIMEOUT_CREATE';

export const SET_ERROR = 'SET_ERROR';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';

export const INITIALIZE = 'SITE_INITIALIZATION';
export const CLEAR_LOGIN = 'CLEAR_LOGIN';

export const CHECK_OVER_USER = 'CHECK_OVER_USER';
export const SET_MENU = 'SET_MENU';
export const SWITCH_USER = 'SWITCH_USER';
export const SET_SWITCHED_USER = 'SET_SWITCHED_USER';